import React ,{ useState, useEffect ,useContext}from "react";
import {
  Upload,
  Button,
  Input,
  Card,
  Row,
  Col,
  Form,
  Select,
  Divider,
  Flex,
  Breadcrumb,notification,Tag,Spin
} from "antd";
import { HomeOutlined,LoadingOutlined,PlusOutlined } from "@ant-design/icons";
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import CompanyAPI from '../../restAPI/CompanyAPI';
import SettingAPI from "../../restAPI/SettingAPI";
import { RefreshContext } from "../../RefreshContext";
import { useOutletContext  } from "react-router-dom";

const CompanyProfilePage = () => {
const [form] = Form.useForm();
const { token } = useSelector(state => state.auth);
const {groupId, companyId} = useOutletContext();
// For File Upload--------------------------------
const [fileList, setFileList] = useState([
      {
        companyid: '-1',
        name: 'image.png',
        status: 'done',
        url: null,
      },
    ]);
const [isUpdated,setIsUpdated] = useState(false);
const [previewOpen, setPreviewOpen] = useState(false);
const [previewImage, setPreviewImage] = useState("");
const [loading, setLoading] = useState(false);
const [file, setFile] = useState();
const [isLoad, setIsLoad] = useState(false);
const [uploadingLogo, setUploadingLogo] = useState(false);
const [deletingLogo, setDeletingLogo] = useState(false);
const { refreshLayout } = useContext(RefreshContext);
const [countryCodes, setCountryCodes] = useState([]); // for geting countries
const [stateCodes, setStateCodes] = useState([]); // state codes for country malayasia
const [shouldSubmit, setShouldSubmit] = useState(false); // state for calling the API
//------------------------------------------------------------------------------
const [payload, setPayload] = useState({
    "_id": "",
    "companyName": "",
    "tin": "",
    "registrationType": "",
    "registrationValue": "",
    "sst": "",
    "ttx": "",
    "msicCode": "",
    "msicDescription": "",
    "countryCode": "",
    "countryName": "",
    "status": 1,
    "email": "",
    "contactNumber": "",
    "addressLine1": "",
    "addressLine2": "",
    "addressLine3": "",
    "postalZone": "",
    "city": "",
    "stateName": "",
    "stateCode": "",
    "groupId": "",
    "businessActivityDescription":"",
    "profilePicture": ""
  })
    //-----------------------Notifications-----------------------
    const [api, contextHolder] = notification.useNotification();
    const openNotificationWithIcon = (type, message, description, placement) => {
      api[type]({
        message: message,
        description: description,
        placement
    });
    };
  //-------------------------API Call for get company data----------------------------------------------
    const getCompanyById = async (id) => {   
          await CompanyAPI.getCompanyById(token, localStorage.getItem('groupId'), localStorage.getItem('companyId'), id).then((res) => {
          //await CompanyAPI.getMyCompany(token, localStorage.getItem('groupId'), localStorage.getItem('companyId')).then((res) => {
            if (res?.data) {
             console.log("API Data :",JSON.stringify(res.data));
              let status = 1;
              if(res.data.status){
                status = 1;
              }
              else{
                status = 0;
              }
              setPayload({
                "_id": res.data._id,
                "companyName": res.data.name,
                "tin": res.data.tin,
                "registrationType": res.data.registrationType,
                "registrationValue": res.data.registrationValue,
                "sst": res.data.sst,
                "ttx": res.data.ttx,
                "msicCode": res.data.msic.msicCode,
                "msicDescription": res.data.msic.description,
                "countryCode": res.data.country.countryCode,
                "countryName": res.data.country.countryName,
                "status": status,
                "email": res.data.email,
                "contactNumber": res.data.contactNumber,
                "addressLine1": res.data.address.addressLine1,
                "addressLine2": res.data.address.addressLine2,
                "addressLine3": res.data.address.addressLine3,
                "postalZone": res.data.address.postalZone,
                "city": res.data.address.city,
                "stateName": res.data.address.state.name,
                "stateCode": res.data.address.state.code,
                "groupId": res.data.groupId,
                "businessActivityDescription":res.data.businessActivityDescription,
                //"profilePicture": (res.data.companyLogo.split("/").pop() !== "undefined" && res.data.companyLogo.split("/").pop() !== null)?res.data.companyLogo : null
                "profilePicture": (res.data.companyLogo !== "undefined" && res.data.companyLogo !== null) ? res.data.companyLogo : null,
              "projectId": res.data.projectId,
              "templateKey":res.data.templateKey,
              "queue":res.data.queue,

              });

              /*if (res.data.companyLogo.split("/").pop() !== "undefined" && res.data.companyLogo.split("/").pop() !== null ) {

                  setFileList([{ url: res.data.companyLogo }]);
              } else {
                  setFileList([]); // Empty fileList when no profile picture
              }*/
             if (res.data.companyLogo !== undefined && res.data.companyLogo !== null ) {
                  setFileList([{ url: res.data.companyLogo }]);
              } else {
                  setFileList([]); // Empty fileList when no profile picture
              }
              setIsLoad(true);
              console.log(payload);
            }
        }).catch(err => {
            console.log("error getting company data :", err);
        })
      };

//----------------------------------------------------------------------API call for getting Countries----------------------------------
 const getCountryCodes = async () => {
    //alert(companyId);
    await CompanyAPI.getCountryCodes(
      token,
      localStorage.getItem("groupId"),
      localStorage.getItem("companyId")
    )
      .then((res) => {
        if (res?.data) {
          console.log(JSON.stringify(res.data));
          const rows = [];
          res.data.map((rowValue) => {
            rows.push({ value: rowValue.code, label: rowValue.name.toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ') })});
         rows.sort((a, b) => a.label.localeCompare(b.label));
         const malaysiaIndex = rows.findIndex(item => item.value.toUpperCase() === "MYS");
         const [malaysia] = rows.splice(malaysiaIndex, 1);
         rows.unshift(malaysia);
        setCountryCodes(rows);
        }
      })
      .catch((err) => {
        console.log("error getting contry codes data :", err.message);
      });
  };

//-----------------------------------------------------------------------------------API call for getting States according to Malayasia-----------------------------
  const getStateCodes = async () => {
      await CompanyAPI.getStateCodes(
        token,
        localStorage.getItem("groupId"),
        localStorage.getItem("companyId")
      )
        .then((res) => {
          if (res?.data) {
            //console.log(JSON.stringify(res.data));
            const rows = [];
            res.data.map((rowValue) => {
              rows.push({ value: rowValue.code, label: rowValue.state });
            });
            setStateCodes(rows);
          }
        })
        .catch((err) => {
          console.log("error getting state codes data :", err.message);
        });
  };

  //------------------------------------------------------------------------------------Edit API call------------------------------------------------------------------------
   const submitCompanyDetails = async () => {
      //setShowPopconfirm(false);
      const formData = {
        "name": payload.companyName,
        "tin": payload.tin,
        "registrationType": payload.registrationType,
        "registrationValue": payload.registrationValue,
        "sst": payload.sst,
        "ttx": payload.ttx,
        "msic": {
          "msicCode": payload.msicCode,
          "description": payload.msicDescription,
        },
        "country": {
          "countryName": payload.countryName,
          "countryCode": payload.countryCode,
        },
        "classificationCode":payload.classificationCode,
        "status": payload.status,
        "email": payload.email,
        "contactNumber": payload.contactNumber,
        "address": {
          "addressLine1": payload.addressLine1,
          "addressLine2": payload.addressLine2,
          "addressLine3": payload.addressLine3,
          "postalZone": payload.postalZone,
          "city": payload.city,
          "state": {
            "name": payload.stateName,
            "code": payload.stateCode,
          }
        },
        "groupId": localStorage.getItem('groupId'),
        "projectId": payload.projectId,
        "templateKey":payload.templateKey,
        "queue":payload.queue,
      };
      console.log("Company Update data  ",JSON.stringify(formData));
    
      await CompanyAPI.updateCompany(token, localStorage.getItem('groupId'),  localStorage.getItem('companyId'), payload._id, formData)
        .then((response) => {
          console.log("Responce :- ",JSON.stringify(response));
            //onClose();
            refreshLayout();
            openNotificationWithIcon('success', "Company update was Successful", `${response.message}`, 'bottomLeft');
            setIsUpdated(false);
        })
        .catch((err) => {
           console.log("Responce error :- ",JSON.stringify(err));
            if (err.response) {
                openNotificationWithIcon('error', 'Company update failed', `${err.response.data.message}`, 'bottomLeft');
            } else {
                openNotificationWithIcon('error', 'Company update failed', `${err.message}`, 'bottomLeft');
            }
        });
    }
//-----------------------------End of API call--------------------------------------

//--------------------------------------------------------------Form element methodes------------------------------------------------------------------------
const OnCountryChange = (value) => {
    let contry = countryCodes.filter(function (obj) {

      return obj.value === value;
    });
    console.log('coutnry select ',contry)
    console.log('coutnry select VALUE ',value)
  
    //set the country in payLoad regurd
// populate and change the state according to country change
    if(value ==="MYS")
      {
          getStateCodes();
          //change the state value
          setPayload((prev)=>({
            ...prev,
            countryCode: contry[0].value,
            countryName: contry[0].label,
            stateName: "",
            stateCode: ""}));
             form.setFieldsValue({
           state: 'Select State',
    });
      }
      else
      {
        setStateCodes([]);
        //change the state value to not applicable
        setPayload((prev)=>({
          ...prev,
          countryCode: contry[0].value,
          countryName: contry[0].label,
          stateName: "Not Applicable",
          stateCode: "17"}));
           form.setFieldsValue({
           state: 'Not Applicable',
    });

      }
};
const OnStateChange = (value) => {
  console.log("State Value",value);
    let state = stateCodes.filter(function (obj) {
      return obj.value === value;
    });

    if (state.length > 0) {
      state.map((rowValue) => {
        setPayload((prev)=>({
          ...prev,
          stateName: rowValue.label,
          stateCode: rowValue.value,
          
        }));
      });
    }
  };
//-----------------------------------------------------------------End of Form Elements-----------------------------------------------------------------------

  const onFinish = (values) => {
    console.log("Calling Update in Company Profile ",JSON.stringify(values));
    // state should change
    //we are only changing the payload values of :- Country, Email address, Contact Number, Address Line 1, Line 2, Line 3, City, and State
    let country_Name = countryCodes.find(country => country.value.toLowerCase() === values.country.toLowerCase());
    console.log("country Object :-,",JSON.stringify(country_Name));
     setPayload((prev)=>({
          ...prev,
          countryCode: country_Name.value,
          countryName: country_Name.label,
          email: values.email,
          contactNumber: values.contactNumber,
          addressLine1: values.addressLine1,
          addressLine2: values.addressLine2,
          addressLine3: values.addressLine3,
          city: values.city
          //stateName: rowValue.label,
          //stateCode: rowValue.value,
          
        }));   
    //console.log("On Update  :-" ,JSON.stringify(payload));
    setShouldSubmit(true); // This triggers the useEffect
  };

  const goHome = () => {
    navigate("../dashboard");
  };

    useEffect(() => {
      //decode token
      if (token !== null) {
        const groupId = localStorage.getItem('groupId');
        const comPanyId = localStorage.getItem('companyId');
        console.log("Group :", groupId);
        console.log("Company :", comPanyId);
        console.log("Token :", token);
        getCountryCodes();
        getStateCodes();
        getCompanyById(comPanyId);
      }
    }, [token,groupId, companyId]);

    useEffect(()=>
    { 
      if (shouldSubmit) {
      submitCompanyDetails();
      setShouldSubmit(false);
    }
    },[payload,shouldSubmit]);

//--------------------------------File Upload Methodes--------------------------------------
const beforeUpload = async (file) => {

  const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
  const isLt2M = file.size / 1024 / 1024 < 2;

  if(localStorage.getItem('companyId') === null)
  {
    return false;
  }

  if (!isJpgOrPng) {
    //message.error("You can only upload JPG/PNG files");
    openNotificationWithIcon(
      "error",
      "Company profile picture update error",
      `You can only upload JPG/PNG files`,
      "bottomLeft"
    );
    return false;
  }

  if (!isLt2M) {
   // message.error("Image must be smaller than 2MB");
    openNotificationWithIcon(
      "error",
      "Company profile picture update error",
      `Image must be smaller than 2MB`,
      "bottomLeft"
    );
    return false;
  }
  setFile(file);
  //isUpdated.current = true;
  setPayload({
    ...payload,
    profilePicture: file,
  });
  if(isJpgOrPng && isLt2M)
    {
      
      if(fileList.url === null || fileList.url === undefined  || fileList.url !== payload.profilePicture)
      {

        await uploadProfilePicture(file);
      }
    }
  //return isJpgOrPng && isLt2M;
  return false;
    
};

const handleChange = ({ fileList: newFileList }) => {

  if(localStorage.getItem('companyId') === null)
    {
      openNotificationWithIcon(
          "info",
          "Information",
          `Please select Group and Company first.`,
          "bottomLeft"
        );
        return false;
    }
    else{

      const isValidFile = newFileList.every(
        (file) =>
          (file.type === "image/jpeg" || file.type === "image/png") &&
          file.size / 1024 / 1024 < 2
      );
    
      if (!isValidFile) {
        return false;
      }
    
      setFileList(newFileList);
    
      setLoading(false);
    }

};

const handlePreview = async (file) => {

    if (!file.url && !file.preview) {
      const reader = new FileReader();
      reader.readAsDataURL(file.originFileObj);
      reader.onload = () => {
        file.preview = reader.result;
        setPreviewImage(reader.result);
      };
    } else {
      setPreviewImage(file.url || file.preview);
    }
    setPreviewOpen(true);

};

const handleRemove = async (file) => {
  await deleteProfilePicture();
};

const uploadButton = (
  <div>
    {(uploadingLogo || deletingLogo) ? <Spin size="small" /> : (loading ? <LoadingOutlined /> : <PlusOutlined />)}
    <div style={{ marginTop: 8 }}>{(uploadingLogo || deletingLogo) ? 'Processing...' : 'Upload'}</div>
  </div>
);

  const uploadProfilePicture = async (file) => {
    setUploadingLogo(true);
    
    if (payload.profilePicture !== undefined ) {
      const profilePicture = new FormData();
      //profilePicture.append("logo", payload.profilePicture);
      profilePicture.append("logo", file);

      await SettingAPI.uploadCompanyProfilePicture(
        token, 
        localStorage.getItem('groupId'),
        localStorage.getItem('companyId'), 
        profilePicture
      )
        .then((response) => {
          refreshLayout();
          openNotificationWithIcon('success', "Company logo updation", `${response.message}`, 'bottomLeft');
        })
        .catch((err) => {
          if (err.response) {
            openNotificationWithIcon('error', 'Company logo updation', `${err.response.data.message}`, 'bottomLeft');
          } else {
            openNotificationWithIcon('error', 'Company logo updation', `${err.message}`, 'bottomLeft');
          }
        })
        .finally(() => {
          setUploadingLogo(false);
        });
    }
    else {
      openNotificationWithIcon('error', 'Company logo updation', 'Profile picture update failed', 'bottomLeft');
      setUploadingLogo(false);
    } 
  }

  const deleteProfilePicture = async () => {
      setDeletingLogo(true);
      let deleteProfilePictureMsg = "";
      await SettingAPI.deleteCompanyProfilePicture(
        token,
        localStorage.getItem("groupId"),
        localStorage.getItem("companyId"),
      )
        .then((response) => {
          refreshLayout();
          openNotificationWithIcon(
            "success",
            "Successful",
            `${response.message}`,
            "bottomLeft"
          );
        })
        .catch((err) => {
          if (err.response) {
            openNotificationWithIcon(
              "error",
              "Delete Profile picture failed",
              `${err.response.data.message}`,
              "bottomLeft"
            );
          } else {
            openNotificationWithIcon(
              "error",
              "Delete Profile picture failed",
              `${err.message}`,
              "bottomLeft"
            );
          }
          return deleteProfilePictureMsg;
        })
        .finally(() => {
          setDeletingLogo(false);
        });
    };

   const onValuesChange = (changedValues, allValues) => {
    console.log('Changed:', changedValues);
    setIsUpdated(true);
    //setIsModified(true);
  };
//-----------------------------------End of File Upload-----------------------------------------------------------------------------------------------------------

  const navigate = useNavigate();
  return (
    
    <>
    {isLoad &&( 
      <>
      {/* Breadcrumb Row */}
      <Row>
      {contextHolder}
        <Col md={24}>
          <Breadcrumb style={{ margin: "16px 0" }}>
            <Breadcrumb.Item href="/dashboard">
              <HomeOutlined />
            </Breadcrumb.Item>
            <Breadcrumb.Item>Company Profile</Breadcrumb.Item>
          </Breadcrumb>
        </Col>
      </Row>

      {/* Outer Container */}
      
      <div className="border-container">
        {/* Home Button */}
        <Button
          type="primary"
          variant="dashed"
          className="card-button"
          size="large"
          icon={<HomeOutlined />}
          onClick={goHome}
          shape="circle"
        ></Button>

        {/* Main Card */}
        <Card title="Company Profile" style={{ minHeight: "100vh" }}>
          {/* Upload Section */}
          <Row>
            <Col md={24}>
              <Flex justify="center" align="middle">
                <Upload
                    name="file"
                    maxCount={1}
                    listType="picture-circle"
                    fileList={fileList}
                    onPreview={handlePreview}
                    onChange={handleChange}
                    beforeUpload={beforeUpload}
                    showUploadList={{ showPreviewIcon: false, showRemoveIcon: !uploadingLogo && !deletingLogo }}
                    onRemove={handleRemove}
                    disabled={uploadingLogo || deletingLogo}
                  >
                    {fileList.length === 0 && uploadButton}
                  </Upload>
              </Flex>
            </Col>
          </Row>

          {/* Form with horizontal layout, labels aligned left */}
          <Form
            form={form}
            layout="horizontal"
            labelAlign="left"
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
            onFinish={onFinish}
            onValuesChange={onValuesChange}
            initialValues={{email:payload["email"],country:payload?.countryCode|| "Select Country",contactNumber:payload?.contactNumber,addressLine1:payload?.addressLine1,addressLine2:payload?.addressLine2,
              addressLine3:payload?.addressLine3,city:payload?.city,state:payload?.stateCode || (payload.countryName === "Malaysia"?"Select State":"Not Applicable")
            }}
          >
            <Row gutter={104}>
              <Col lg={12}>
                {/* Divider: General Information */}
                <Divider  style={{
                        borderColor: '#7cb305'
                      }}>General Information</Divider>
                <Row gutter={24}>
                  <Col span={24}>
                    <Form.Item label="Company Name">
                      <Input size="large" placeholder="Company Name" name='companyName' value={payload?.companyName} readOnly/>
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item label="TIN">
                      <Input size="large" placeholder="TIN" name = 'tin' value={payload?.tin} readOnly/>
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item
                      label="Registration Type"  >
                      <Select size="large" placeholder="Select Registration Type" name="registrationType" value={payload?.registrationType}   readOnly
                       options={[
                        {
                          value: 'NRIC',
                          label: 'NRIC',
                        },
                        {
                          value: 'Passport number',
                          label: 'Passport number',
                        },
                        {
                          value: 'Business registration number',
                          label: 'Business registration number',
                        },
                        {
                          value: 'Army number',
                          label: 'Army number',
                        },
                      ]}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item
                      label="Registration Value" >
                      <Input size="large" placeholder="Registration Value" name="registrationValue" value={payload?.registrationValue} readOnly/>
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item label="SST" >
                      <Input size="large" placeholder="SST" name="sst" value={payload?.sst} readOnly/>
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item label="TTX" >
                      <Input size="large" placeholder="TTX" name="ttx" value={payload?.ttx} readOnly />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item
                      label="Business Activity Description">
                      <Input
                        size="large" placeholder="Business Activity Description"  name="businessActivityDescription" value={payload?.businessActivityDescription} readOnly
                      />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item label="MSIC Code">
                      <Input size="large" placeholder="MSIC Code"  name="msicCode" value={payload?.msicCode} readOnly/>
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                   <Tag bordered={false} color="geekblue">This field permits modification</Tag>
                    <Form.Item
                      label="Country"
                      name="country"
                      rules={[
                      {
                        required: true,
                        message: "Please Select a Country",
                      },
                      ]} required /*help={<Tag bordered={false} color="geekblue" style={{ marginTop: '4px' }}>This field permits modification</Tag>}*/>
                     {/*<Input size="large" placeholder="Country" name="country" value={payload?.countryName} />*/}
                     <Select
                      showSearch
                      name="country"
                      placeholder="Select country"
                      //value={payload?.countryName|| "Select Country"}
                      optionFilterProp="label"
                      onChange={OnCountryChange}
                      size="large"
                      options={countryCodes}
                    />

                    </Form.Item>
                  </Col>
                </Row>
               
              </Col>

              <Col lg={12}>
                {/* Divider: Contact Information */}
                <Divider  style={{
                        borderColor: '#7cb305'
                      }}>Contact Information</Divider>
                <Row gutter={24}>
                  <Col span={24}>
                   <Tag bordered={false} color="geekblue">Fields in This Coloumn permits modification</Tag>
                    <Form.Item
                      label="Email Address"
                      name="email"
                       rules={[
                      {
                        required: true,
                        message: "Please Enter Email",
                      },
                      {
                        type:"email",
                        message: "Please enter a valid email address",                    
                      },
                    ]}
                    required>
                      <Input size="large"   value={payload["email"]}  placeholder="Email Address"/>
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item
                      label="Contact Number"
                      name="contactNumber"
                      rules={[
                      {
                        required: true,
                        message: "Please Enter Contact no!",
                      },
                     {
                        pattern: /^(\+)?[0-9]{10,15}$/,
                        message: 'Contact number must be 10 - 15 digits',
                      },
                    ]}
                        required
                       >
                      <Input size="large" placeholder="Contact Number"   value={payload?.contactNumber} />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item
                      label="Address Line 1" 
                      name="addressLine1"
                      rules={[
                      {
                        required: true,
                        message: "Please Enter Adress Line 1!",
                      },
                    ]}
                        required>
                      <Input size="large" placeholder="Address Line 1"  value={payload?.addressLine1}/>
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item label="Address Line 2"
                     name="addressLine2">
                      <Input size="large" placeholder="Address Line 2"  value={payload?.addressLine2}/>
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item label="Address Line 3"
                    name="addressLine3">
                      <Input size="large" placeholder="Address Line 3"  value={payload?.addressLine3}/>
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item
                      label="City" name="city"
                      rules={[
                      {
                        required: true,
                        message: "Please Enter City Name",
                      },
                    ]}
                        required>
                      <Input size="large" placeholder="City Name"  value={payload?.city} />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item label="State"
                      name ='state'
                       rules={[
                              ({ getFieldValue }) => ({
                                validator(_, value) {
                                  // Apply validation only if "item1" is selected
                                  if ((getFieldValue('country') === 'MYS') && value.trim() === 'Select State') {
                                    return Promise.reject(new Error('State is required for Selected Country!'));
                                  }
                                  return Promise.resolve();
                                },
                              }),
                            ]}>
                      <Select
                        showSearch
                        placeholder="Select State"
                        optionFilterProp="label"
                        onChange={OnStateChange}
                        size="large"
                        options={stateCodes}
                        disabled = {payload.countryName !=="Malaysia"}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                  </Col>
                </Row>
              </Col>
            </Row>

            {/* Submit Button Row */}
            <Row style={{ marginTop: "24px" }}>
              <Col md={8} />
              <Col md={8}>
                <Form.Item wrapperCol={{ span: 24 }}>
                   <Button  type="primary" htmlType="submit" block size="large" disabled={!isUpdated}>
                    Save
                  </Button> 
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Card>      
      </div>
      </>
    )}
    </>
  );
};

export default CompanyProfilePage;
